import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { ApprovalFormTable } from '@/components/Approval/@components/ApprovalFormTable';
import {
  calcAccumulatedRate,
  formatEntNumber,
  type EntTotalAmountRow,
} from '@/utils/approval/entExpense';
import UsageCell from './UsageCell';
import { EditTotalAmountArea } from './styles';

type TotalAmountTableProps = {
  rows: EntTotalAmountRow[];
  /** 작성 화면 — 위아래 검은 선, 좌우 바깥선 없음 */
  editMode?: boolean;
};

const EMPTY_ROW: EntTotalAmountRow = {
  label: '',
  budgetTotl: 0,
  remain: 0,
  amount: 0,
};

/** 213 금번 품의 사용 예정(분류별 집계) — 작성·조회 공용 */
const TotalAmountTable = ({
  rows,
  editMode = false,
}: TotalAmountTableProps) => {
  const { t } = useTranslation();
  const list = rows.length ? rows : [EMPTY_ROW];
  const grandTotal = Math.round(rows.reduce((sum, r) => sum + r.amount, 0));
  const Area = editMode ? EditTotalAmountArea : Fragment;
  return (
    <Area>
      <ApprovalFormTable className="ent-total-amount-table">
        <colgroup>
          <col />
          <col style={{ width: 140 }} />
          <col style={{ width: 140 }} />
          <col style={{ width: 160 }} />
          <col style={{ width: 160 }} />
        </colgroup>
        <thead>
          <tr>
            <th className="align-left">{t('분류')}</th>
            <th className="align-right">{t('전체예산')}</th>
            <th className="align-right">{t('잔여예산')}</th>
            <th className="align-center">{t('금번품의 사용 예산')}</th>
            <th className="align-left">{t('누적집행률')}</th>
          </tr>
        </thead>
        <tbody>
          {list.map((row, idx) => (
            // eslint-disable-next-line react/no-array-index-key
            <tr key={`${row.label}-${idx}`}>
              <td className="align-left">{row.label}</td>
              <td className="align-right">{formatEntNumber(row.budgetTotl)}</td>
              <td className="align-right">{formatEntNumber(row.remain)}</td>
              <td className="align-right">{formatEntNumber(row.amount)}</td>
              <td>
                <UsageCell rate={calcAccumulatedRate(row)} />
              </td>
            </tr>
          ))}
        </tbody>
        <tfoot>
          <tr>
            <td className="align-left">
              <strong>{t('총계')}</strong>
            </td>
            <td className="align-right" colSpan={3}>
              <strong>{formatEntNumber(grandTotal)}</strong>
            </td>
            <td />
          </tr>
        </tfoot>
      </ApprovalFormTable>
    </Area>
  );
};

export default TotalAmountTable;
